// src/app/rail-brand.tsx
// The top of the rail (design log 12 Oct, Rule "rail toggle on the logo"; amended 19 Oct, Antonin: "the logo in the
// closed rail should be full size, same as when open, and the expand control next to it"):
//   - the full Scrips wordmark (32 tall) at the same size and place folded and open; it opens Today.
//   - the expand / collapse toggle, a 32px icon button right after it, in the same place in both states
//     (Lucide panel icon, default stroke, the app's instant icon-button tooltip).
// Folded, the row runs past the 56px rail and the top bar's Back + crumbs start after it. `[` still toggles
// (rail-state.ts). Looks: src/styles/showcase-bridge.css under `/* rail labels */`.
import { PanelLeftClose, PanelLeftOpen } from 'lucide-react';
import { ScripsWordmark } from './scrips-wordmark';

interface RailBrandProps {
  expanded: boolean;
  onToggle: () => void;
  onHome: () => void;
}

export function RailBrand({ expanded, onToggle, onHome }: RailBrandProps) {
  const ToggleGlyph = expanded ? PanelLeftClose : PanelLeftOpen;
  return (
    <>
      <button type="button" data-slot="rail-brand" aria-label="Scrips, go to Today" className="rail-brand-home" onClick={onHome}>
        <ScripsWordmark height={32} />
      </button>
      <button
        type="button"
        data-slot="rail-toggle"
        aria-label={expanded ? 'Collapse navigation' : 'Expand navigation'}
        aria-expanded={expanded}
        aria-keyshortcuts="["
        className="rail-brand-toggle"
        onClick={onToggle}
      >
        <ToggleGlyph className="size-5" aria-hidden="true" />
      </button>
    </>
  );
}
